import ol = require("ol");
import MapView = require("../../views/MapView");
import Utils = require("../../utils");
import Portal = require("portal-gis");
import globals = require("../../../globals");
import { layerList } from "../../../globals";
const log = Utils.log;

/***
 * register/unregister layer events so events associated with a layer are only handled
 * when the layer is visible
 */
class EventHandler {
    static sourceEvents = "addfeature,change,changefeature,clear,removefeature".split(",").sort();
    static viewEvents = "extent,maxResolution,minResolution,opacity,source,visible,zIndex".split(",").sort();

    static about = `
Register/unregister [source](http://openlayers.org/en/latest/apidoc/ol.source.html) and [layer](http://openlayers.org/en/latest/apidoc/ol.layer.html) events 
and limit availability based on visibility depending upon configuration.

source events:
    *${EventHandler.sourceEvents.join("\n    *")}

view change events:
    *${EventHandler.viewEvents.join("\n    *")}

Both source and view events trigger a corresponding layer-_event_ on the event bus.  The view events are triggered when the associated
value changes.
`;

    static defaults = {
        "when-hidden": "false",
        "when-visible": "true",
    }

    static options = {
        "when-hidden": {
            "about": "only fires when layer is hidden, defaults to the inverse of when-visible",
            "domain": "true|false",
            "default": EventHandler.defaults["when-hidden"],
        },
        "when-visible": {
            "about": "only fires when layer is visible",
            "domain": "true|false",
            "default": EventHandler.defaults["when-visible"],
        },
    }

    static register(args: {
        config: Portal.MapLayerLeaf;
        view: MapView;
        source: ol.source.Source;
        layer: ol.layer.Layer;
    }) {

        let events = args.config.Events.Events;
        let view = args.view;
        let source = args.source;
        let layer = args.layer;
        let mediator = view.mediator;
        let layersList = mediator.model.get('mapView').model.data.Layers.ActiveLayers;
        EventHandler.sourceEvents.map(event => source.on(event, sourceArgs => {
            view.trigger("layer-" + event, sourceArgs);
        }));

        EventHandler.viewEvents.map(event => layer.on("change:" + event, sourceArgs => {
            view.trigger("layer-" + event, sourceArgs);
            
        if(event == 'visible'){
            if(layersList != null && layersList.filter(e => e.id === layer.values_.id).length > 0){
                 let index = layersList.findIndex((obj => obj.id == layer.values_.id));
                 layersList[index].visible = layer.values_.visible;
            }
            mediator.model.get('civics-channel').trigger("civics:layer-visible", layersList);
        }

        }));
        mediator.model.get('civics-channel').trigger("civics:get-active-layers", layersList);
        // foward mapView events
        events
            .filter(event => event.name.indexOf("layer-") === 0)
            .forEach(event => {
                log("register event forwarding: ", event.name);

                let eventOptions = _.defaults(Utils.asDictionary(event.Options.Values), EventHandler.defaults);
                let whenVisible = "true" === eventOptions["when-visible"];
                let whenHidden = "true" === eventOptions["when-hidden"];

                Utils.ifOption(eventOptions, "when-visible", v => {
                    whenVisible = (v === "true");
                    whenHidden = !whenVisible;
                });
                Utils.ifOption(eventOptions, "when-hidden", v => whenHidden = (v === "true"));

                view.on(event.name, layerArgs => {
                    // BUG: map not available here!
                    let resolution = view.map.getView().getResolution();
                    let visible =
                        layer.getVisible()
                        && layer.getMinResolution() <= resolution
                        && resolution < layer.getMaxResolution();
                    if (whenVisible === visible || whenHidden !== visible) {
                        if (layerArgs.target === source || layerArgs.target === layer) {
                            // only handle events for this layer (or source)
                            log("vector event:", event.name);
                            // execute the event
                            Utils.execute(event, mediator, {
                                layer: layer,
                                source: source,
                                feature: layerArgs.feature
                            });
                        }
                    }
                });

            });


        events.forEach(event => {

            let eventOptions = Utils.asDictionary(event.Options.Values);
            let whenVisible = true;
            let whenHidden = false;
            Utils.ifOption(eventOptions, "when-visible", v => {
                whenVisible = (v === "true");
                whenHidden = !whenVisible;
            });
            Utils.ifOption(eventOptions, "when-hidden", v => whenHidden = (v === "true"));

            Utils.split(event.name).forEach(eventName => {

                log("register event forwarding: ", eventName);
                mediator.on(eventName, layerArgs => {
                    let visible = layer.getVisible();
                    if (whenVisible === visible || whenHidden !== visible) {
                        log("layer event:", eventName);
                        // execute the event
                        Utils.execute(event, mediator, layerArgs);
                    }
                });

            });

        });
    }
}

export = EventHandler;